import { LOGO_URL } from "../../constants/brand";

export function TrustPortalWatermark() {
  return (
    <div className="fixed inset-0 flex items-center justify-center pointer-events-none overflow-hidden z-0" aria-hidden="true" data-testid="trust-portal-watermark">
      <img src={LOGO_URL} alt="" className="w-[60vw] max-w-[820px] opacity-[0.08] select-none" style={{ filter: "brightness(0.6) contrast(1.15)" }} draggable="false" />
    </div>
  );
}
